import { io } from 'socket.io-client';
import config, { AUTH_TOKEN_KEY } from '../config';

let socket = null;

const matchedCallback = new Set();
const isLikeMatchedCallback = new Set();
const errorsCallback = new Set();
const endSessionCallback = new Set();

const connect = () => {
  if (socket?.connected) return;

  const token = localStorage.getItem(AUTH_TOKEN_KEY);
  socket = io(`${config.API_BASE_URL}/roulette`, {
    path: '/socket.io',
    auth: { token },
    transports: ['websocket', 'polling'],
  });

  socket.on('match-found', (data) => {
    console.log('[rouletteService] on matched:', data);
    matchedCallback.forEach((callback) => callback(data));
  });

  socket.on('match-user', (data) => {
    console.log('[rouletteService] on match-user:', data);
    isLikeMatchedCallback.forEach((callback) => callback(data));
  });

  socket.on('end-session', (data) => {
    console.log('[rouletteService] on end-session:', data);
    endSessionCallback.forEach((callback) => callback(data));
  });

  socket.on('error', (data) => {
    console.log('[rouletteService] on error:', data);
    errorsCallback.forEach((callback) => callback(data));
  });
};

const disconnect = () => {
  if (socket) {
    socket.disconnect();
    socket = null;
  }
};

const isConnected = () => {
  return socket?.connected || false;
};

const startSearch = () => {
  if (!isConnected()) return;
  socket.emit('start-search');
};

const skipSession = () => {
  if (!isConnected()) return;
  socket.emit('skip-session');
};

const likeToUser = () => {
  if (!isConnected()) return;
  socket.emit('like-to-user');
};

const onMatched = (callback) => {
  matchedCallback.add(callback);
  return () => matchedCallback.delete(callback);
};

const onIsLikeMatched = (callback) => {
  isLikeMatchedCallback.add(callback);
  return () => isLikeMatchedCallback.delete(callback);
};
const onEndSession = (callback) => {
  endSessionCallback.add(callback);
  return () => endSessionCallback.delete(callback);
};

const onErrors = (callback) => {
  errorsCallback.add(callback);
  return () => errorsCallback.delete(callback);
};

export const rouletteService = {
  connect,
  isConnected,
  disconnect,
  startSearch,
  likeToUser,
  skipSession,
  onMatched,
  onIsLikeMatched,
  onEndSession,
  onErrors,
};

export default rouletteService;
